import { render, staticRenderFns } from "./ShowPaciente.vue?vue&type=template&id=6ccdb2f4"
import script from "./ShowPaciente.vue?vue&type=script&lang=ts"
export * from "./ShowPaciente.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports